import { User } from 'shared/types/user'

export interface RegisterRequest {
  account_type: 'personal' | 'organization'
  first_name: string
  last_name: string
  email: string
  password: string
  repeat_password: string
  country_code?: string
  phone_number?: string
}

export interface RegisterResponse {
  message: string
  data: User
}

export interface RegisterErrorResponse {
  message: string
  error?: Record<string, string[]>
}
